import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import './CrearNota.css';

const CrearNota = ({ selectedDate, onClose, onNotaCreated  }) => { 
  const apiUrl = process.env.REACT_APP_API_URL;

  const [observacion, setObservacion] = useState('');

  // Log para verificar que `selectedDate` se recibe correctamente
  console.log("Fecha recibida en CrearNota:", selectedDate);

  // Formatea la fecha para mostrar el día con el formato adecuado
  const fechaObjeto = new Date(selectedDate);
  const fechaFormateada = new Intl.DateTimeFormat('es-ES', { 
    weekday: 'long', 
    day: 'numeric', 
    month: 'long' 
  }).format(fechaObjeto);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const nuevaNota = {
      fecha: selectedDate, // Usar la fecha que recibe el componente
      observacion: observacion
    };

    console.log("Enviando nota:", nuevaNota);

    try {
      await axios.post(`${apiUrl}/api/crearnota/`, nuevaNota);
      console.log("Nota guardada correctamente.");
      onNotaCreated();
      setObservacion('');
 

      onClose(); // Cierra el modal
    } catch (error) {
      console.error("Error al guardar la nota:", error);
      alert("Hubo un problema al guardar la nota.");
    }
  };

  return (
    <div className="nota-container">
      <div className="nota-header">
        <h2 className="nota-title">Nota para el {fechaFormateada}</h2>
      </div>

      <form onSubmit={handleSubmit} className="nota-form">
        <div className="mb-3">
          <label htmlFor="observacion" className="form-label nota-label">
            Observación:
          </label>
          <textarea
            id="observacion"
            className="form-control nota-textarea"
            rows="5"
            value={observacion}
            onChange={(e) => setObservacion(e.target.value)}
            placeholder="Escribe aquí tu nota..."
          />
        </div>

        <div className="nota-buttons">
          <Button 
            variant="outline-danger" 
            className="nota-btn"
            onClick={() => {
              setObservacion('');
              onClose();
            }}
          >
            Cancelar
          </Button>
          <Button 
  variant="primary" 
  type="submit" 
  className="nota-btn"
  disabled={!observacion.trim()} // Bloquea el botón si el campo está vacío
>
  Guardar Nota
</Button>

        </div>
      </form>
    </div>
  );
};

export default CrearNota;
